<template>
    <div class="yslx_home">
        <div class="yslx1">

        </div>
        <div class="yslx2">
            <div class="y2_title">
                <div class="y2_item" @click="countryDetail(0,1)">
                    <p>英国艺术留学</p>
                </div>
                <div class="y2_item" @click="countryDetail(1,2)">
                    <p>美国艺术留学</p>
                </div>
                <div class="y2_item" @click="countryDetail(2,11)">
                    <p>日本艺术留学</p>
                </div>
                <div class="y2_item" @click="countryDetail(3,5)">
                    <p>加拿大艺术留学</p>
                </div>
                <div class="y2_item" @click="countryDetail(4,6)">
                    <p>澳大利亚艺术留学</p>
                </div>
                <div class="y2_item" @click="countryDetail(5,9)">
                    <p>德国艺术留学</p>
                </div>

            </div>
            <div class="n2_cont2">
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 540.png" alt="">
                    <p>申请时间：</p>
                    <div>{{ theCountryData.time }}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 541.png" alt="">
                    <p>语言要求：</p>
                    <div>{{ theCountryData.language }}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 542.png" alt="">
                    <p>申请材料：</p>
                    <div>{{ theCountryData.material }}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 543.png" alt="">
                    <p>绩点要求：</p>
                    <div>{{ theCountryData.gpa }}</div>
                </div>
                <div class="n2_p">
                    <img src="../img/留学资讯/Group 544.png" alt="">
                    <p>文书要求：</p>
                    <div>{{ theCountryData.writ }}</div>
                </div>

                <a href="javascript:void(0)" class="kefu_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                    <p>了解更多申请详情</p>
                </a>

            </div>

        </div>

        <div class="yslx3">
            <div class="section_box">
                <div class="section_title_cn">热门学校推荐</div>
                <div class="section_title_en">POPULAR SCHOOL RECOMMENDATION</div>
            </div>
            <div class="s1_cont">
                <div class="swiper mySwiper2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in schoolData">
                            <div class="s1_item" v-for="(item2, index2) in item">
                                <img :src="'https://public.rossoarts.com/static/uploads/' + item2.logo" alt="">
                                <p><span>{{ item2.cname }}</span></p>
                                <p>{{ item2.ename }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
            <a href="javascript:void(0)" class="kefu_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <p>如何上艺术名校？</p>
            </a>
        </div>

        <div class="yslx4">
            <div class="section_box">
                <div class="section_title_cn">申请流程</div>
                <div class="section_title_en"> APPLICATION PROGRESS</div>
            </div>
            <div class="y4_cont">

            </div>
            <a href="javascript:void(0)" class="kefu_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <p>我需要怎么准备？</p>
            </a>
        </div>
        <div class="yslx5">
            <div class="section_box">
                <div class="section_title_cn">方案推荐</div>
                <div class="section_title_en">PROJECT RECOMMENDATION</div>
            </div>
            <div class="c2_cont">
                <div class="swiper mySwiperC1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title c2_title1">
                                    <div>专业作品集辅导</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>已具备基础课能力的学生，计划申请艺术设计院校本科、研究生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>多名艺术导师量身制定作品集产出</li>
                                            <li><span></span>海外高等院校教学模式</li>
                                            <li><span></span>四级教学法+五维审核体系</li>
                                            <li><span></span>多元化竞赛资源</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn">
                                            <p>课程详情</p>
                                            <img src="../img/Frame2.png" alt="">
                                        </div>
                                    </a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title3 c2_title">
                                    <div>VIP院校计划</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>申请艺术设计院校本科、研究生的学生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>定制化全套作品集课程</li>
                                            <li><span></span>海外教授多V1辅导</li>
                                            <li><span></span>欧美权威专业TOP3、TOP5、TOP8名校OFFER</li>
                                            <li><span></span>梦校直通车</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn">
                                            <p>课程详情</p>
                                            <img src="../img/Frame2.png" alt="">
                                        </div>
                                    </a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>

                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title4 c2_title">
                                    <div>海外游学与夏校项目</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>15周岁以上高中或大学生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>与海外导师合作，独家定制课程</li>
                                            <li><span></span>沉浸式体验，探索灵感来源</li>
                                            <li><span></span>实际前往院校，深入名校课堂</li>
                                            <br>


                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn">
                                            <p>课程详情</p>
                                            <img src="../img/Frame2.png" alt="">
                                        </div>
                                    </a>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>



                    </div>
                    <!-- <div class="swiper-pagination"></div> -->
                </div>

            </div>
        </div>
        <div class="yslx6">
            <div class="section_box">
                <div class="section_title_cn">热门专业推荐</div>
                <div class="section_title_en">PROJECT MAJOR RECOMMENDATION</div>
            </div>
            <div class="y6_cont">
                <div class="m2_right">
                    <div class="m2_item" @click="jopMajorDetail(1)">
                        <img src="../img/艺术专业/Group 518.png" alt="">
                        <p>服装设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(2)">
                        <img src="../img/艺术专业/Group 519.png" alt="">
                        <p>景观设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(3)">
                        <img src="../img/艺术专业/Group 512.png" alt="">
                        <p>工业设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(4)">
                        <img src="../img/艺术专业/Group 513.png" alt="">
                        <p>插画设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(5)">
                        <img src="../img/艺术专业/Group 514.png" alt="">
                        <p>动画设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(6)">
                        <img src="../img/艺术专业/Group 515.png" alt="">
                        <p>建筑设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(7)">
                        <img src="../img/艺术专业/Group 516.png" alt="">
                        <p>交互设计</p>
                    </div>
                    <div class="m2_item" @click="jopMajorDetail(8)">
                        <img src="../img/艺术专业/Group 517.png" alt="">
                        <p>室内设计</p>
                    </div>
                </div>
            </div>
            <div class="y6_main">
                <img src="../img/yslx/11.jpg" alt="" class="y6_main_img">
            </div>

            <div>
                <a href="javascript:void(0)" class="kefu_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                    <p>如何选择合适的专业？</p>
                </a>
            </div>
        </div>

        <div class="tutors6">
            <div class="section_box">
                <div class="section_title_cn">热门回答</div>
                <div class="section_title_en">POPULAR Q&A</div>
            </div>
            <div class="t6_cont">
                <div class="swiper mySwiperT4">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in qaData">
                            <div v-for="(item2, index2) in item" class="t6_item" @click="t6Show(index * 3 + index2)">
                                <div class="t6_item_show">
                                    <div>Q：{{ item2.question }}</div>

                                </div>

                                <div class="grid">
                                    <div class="t6_item_hid">
                                        <div style="margin-top: .2rem;margin-bottom: .2rem;">A：{{ item2.answer }}</div>

                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="swiper-pagination"></div>
                </div>
            </div>

            <a href="javascript:void(0)" class="kefu_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <p>在线了解更多</p>
            </a>
        </div>

        <div class="yslx7">
            <div class="section_box">
                <div class="section_title_cn">世界名校录取榜</div>
                <div class="section_title_en">RoSSo OFFERLIST</div>
            </div>
            <div class="s1_cont">
                <div class="swiper mySwiper2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in schoolData2">
                            <div class="s1_item" v-for="(item2, index2) in item">
                                <img :src="'https://public.rossoarts.com/static/uploads/' + item2.logo" alt="">
                                <p>{{ item2.cname }}</p>
                                <p>录取<span>{{ item2.admission_num }}</span>人</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>



            </div>
            <a href="javascript:void(0)" class="kefu_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <p>我也想成为其中一员</p>
            </a>
        </div>

        <div class="section33">
            <div class="section_box">
                <div class="section_title_cn">艺术导师</div>
                <div class="section_title_en">ART TUTORS</div>

            </div>

            <div class="s33_togbtn_box">
                <div class="s33_togbtn" @click="togCourses(0)" style="color: #fff;background-color: #5F9DF7;">海外大师</div>
                <div class="s33_togbtn" @click="togCourses(1)" style="background-color: #fff;">学科带头人</div>
            </div>

            <div class="s33_cont1">
                <div class="swiper mySwiper331">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="s33_item" v-for="(item, index) in tutors1Data2" v-if="index < 6"
                                @click="jopTutorDetail(item.id)">
                                <div class="s33imgBox">
                                    <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item.avatar"
                                        alt="">
                                    <img class="s33coverImg" v-if="index == 0 || index == 5"
                                        src="../img/homepage-折叠部分切图/Group 213.png" alt="">
                                    <img class="s33coverImg" v-if="index == 1 || index == 3"
                                        src="../img/homepage-折叠部分切图/Group 214.png" alt="">
                                    <img class="s33coverImg" v-if="index == 2 || index == 4"
                                        src="../img/homepage-折叠部分切图/Group 215.png" alt="">

                                </div>
                                <p class="s33p1">Prof.{{ item.name }}</p>
                                <p class="s33p2">{{ item.major }}</p>
                                <p class="s33p3">{{ item.school | schoolAd }}</p>
                            </div>

                        </div>
                        <div class="swiper-slide">
                            <div class="s33_item" v-for="(item, index) in tutors1Data2" v-if="index > 5"
                                @click="jopTutorDetail(item.id)">
                                <div class="s33imgBox">
                                    <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item.avatar"
                                        alt="">
                                    <img class="s33coverImg" v-if="index == 6 || index == 11"
                                        src="../img/homepage-折叠部分切图/Group 213.png" alt="">
                                    <img class="s33coverImg" v-if="index == 7 || index == 9"
                                        src="../img/homepage-折叠部分切图/Group 214.png" alt="">
                                    <img class="s33coverImg" v-if="index == 8 || index == 10"
                                        src="../img/homepage-折叠部分切图/Group 215.png" alt="">

                                </div>
                                <p class="s33p1">Prof.{{ item.name }}</p>
                                <p class="s33p2">{{ item.major }}</p>
                                <p class="s33p3">{{ item.school | schoolAd }}</p>
                            </div>


                            <div class="s33_item">

                            </div>
                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>


            <div class="s33_cont1" style="display: none;">
                <div class="swiper mySwiper331">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="s33_item" v-for="(item, index) in tutors1Data" v-if="index < 6">
                                <div class="s33imgBox">
                                    <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item.avatar"
                                        alt="">
                                    <img class="s33coverImg" v-if="index == 0 || index == 5"
                                        src="../img/homepage-折叠部分切图/Group 213.png" alt="">
                                    <img class="s33coverImg" v-if="index == 1 || index == 3"
                                        src="../img/homepage-折叠部分切图/Group 214.png" alt="">
                                    <img class="s33coverImg" v-if="index == 2 || index == 4"
                                        src="../img/homepage-折叠部分切图/Group 215.png" alt="">

                                </div>
                                <p class="s33p1">{{ item.name }}</p>
                                <p class="s33p2">{{ item.major }}</p>
                                <p class="s33p3">{{ item.school | schoolAd }}</p>
                            </div>

                        </div>
                        <div class="swiper-slide">
                            <div class="s33_item" v-for="(item, index) in tutors1Data" v-if="index > 5">
                                <div class="s33imgBox">
                                    <img :src="' https://public.rossoarts.com/static/uploads/teacher/' + item.avatar"
                                        alt="">
                                    <img class="s33coverImg" v-if="index == 6 || index == 11"
                                        src="../img/homepage-折叠部分切图/Group 213.png" alt="">
                                    <img class="s33coverImg" v-if="index == 7 || index == 9"
                                        src="../img/homepage-折叠部分切图/Group 214.png" alt="">
                                    <img class="s33coverImg" v-if="index == 8 || index == 10"
                                        src="../img/homepage-折叠部分切图/Group 215.png" alt="">

                                </div>
                                <p class="s33p1">{{ item.name }}</p>
                                <p class="s33p2">{{ item.major }}</p>
                                <p class="s33p3">{{ item.school | schoolAd }}</p>
                            </div>
                            <div class="s33_item">

                            </div>
                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>



        
      <a href="javascript:void(0)" class="s33_btn" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })" style="width: 4rem;">
                <p style="color: #000;">了解更多</p>
            </a>


        </div>

    </div>
</template>
<script>
import Swiper from 'swiper/bundle'
// import  Swiper from 'swiper/vue';
import 'swiper/css';
import "swiper/css/effect-cards";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axios from "axios"
import "@/assets/css/yslx.css"

export default {
    data() {
        return {
            countryData: [
                {
                    time: "11月至次年1月",
                    material: "作品集、1-2本sketchbook",
                    language: "雅思5.5分以上/托福80分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "10月中旬至次年1月中旬",
                    material: "作品集、语言成绩、SAT／ACT",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "大部分院校要求3.0以上",
                    writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
                },

                {
                    time: "9月至次年2月",
                    material: "文书材料、作品集、日语成绩、大学成绩单",
                    language: "日语，成绩需要达到 N1/300分以上",
                    gpa: "大部分院校要求3.2以上",
                    writ: "包括研究计划（论文）、成绩证明书、推荐信等，具体以学校要求为准"
                },
                {
                    time: "12月至次年5月",
                    material: "作品集、德语证明、表格式简历、本科毕业证和学位证",
                    language: "德语，申请时达到B1，入学时达到C1",
                    gpa: "大部分院校要求3.2以上",
                    writ: "具体以学校要求为准"
                },
                {
                    time: "12月至次年2月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
                {
                    time: "8月至12月",
                    material: "作品集、语言成绩、毕业证／在读证明、成绩单、申请文书",
                    language: "托福80分以上／雅思6分以上",
                    gpa: "gpa3.0以上",
                    writ: "包括个人陈述、推荐信等书面材料，具体以学校要求为准"
                },
            ],
            theCountryData: {
                time: "11月至次年1月",
                material: "作品集、1-2本sketchbook",
                language: "雅思5.5分以上/托福80分以上",
                gpa: "大部分院校要求3.0以上",
                writ: "包括个人陈述、Eassy、推荐信等书面材料，具体以学校要求为准"
            },
            schoolData: [],
            schoolData2: [],
            qaData: [],
            tutors1Data2: [],
            tutors1Data: [],
            theCoutryId:1,
        }
    },
    created() {
        this.getSchool()
        this.getQa()
        this.getSchool2()
        this.getTutors1()
        this.getTutors2()
    },
    filters: {

        schoolAd(val) {

            return val.split(",")[0]
        },
    },
    methods: {
        mySwiper331Stick() {
            var swiper = new Swiper(".mySwiper331", {
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                loop: true,
                observer: true,

            });
        },
        getTutors1() {
      axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=1&limit=12").then((data) => {
        // console.log(data.data);
        this.tutors1Data = data.data
        // this.$nextTick(() => {
        //   this.mySwiper331Stick()
        // })
      })
    },
        getTutors2() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstTeacher?category=2&limit=12").then((data) => {
                // console.log(data.data);
                this.tutors1Data2 = data.data
                this.$nextTick(() => {
                    this.mySwiper331Stick()
                })
            })
        },
        togCourses(val) {
            var s33_togbtn = document.getElementsByClassName("s33_togbtn")
            var s33_cont1 = document.getElementsByClassName("s33_cont1")
            for (var i = 0; i < s33_togbtn.length; i++) {
                s33_togbtn[i].style.color = "#000"
                s33_togbtn[i].style.backgroundColor = "#fff"
                s33_cont1[i].style.display = "none"
            }
            s33_togbtn[val].style.color = "#fff"
            s33_togbtn[val].style.backgroundColor = "#5F9DF7"
            s33_cont1[val].style.display = "block"

        },
        getSchool2() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstOffer?limit=36&page=1").then((data) => {
                // console.log(this.arrGroup(data.data.data, 4));
                this.schoolData2 = this.arrGroup(data.data.data, 6)
                this.$nextTick(() => {
                    this.mySwiper2Stick()
                })
            })
        },
        swiperT4() {
            var swiper = new Swiper(".mySwiperT4", {
                autoHeight: true,
                // spaceBetween: 20,
                // loop: true,
                observer: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });

        },
        t6Show(val2) {
            var val = val2
            // console.log('val2',val2,"val",val);
            var t6_item = document.getElementsByClassName("t6_item")
            var grid = document.getElementsByClassName("grid")
            var t6_item_show = document.getElementsByClassName("t6_item_show")
            var t6_item_hid = document.getElementsByClassName("t6_item_hid")
            // t6_item_hid[val].style.height = "auto"
            // this.flag = !this.flag
            // console.log(grid, val);
            if (grid[val].style.gridTemplateRows == "0fr") {
                // 不出
                // console.log("合起");
                grid[val].style.gridTemplateRows = "1fr";
                // t6_item_show[val].style.backgroundColor = "#5f9df7"
                // t6_item_show[val].style.border = "none"
                // t6_item_show[val].style.margin = "0rem"

            } else {
                // 出
                // console.log("展开");
                grid[val].style.gridTemplateRows = "0fr";
                // t6_item_show[val].style.backgroundColor = "#FB6333"
                // t6_item_show[val].style.border = ".02rem solid #000"
                // t6_item_show[val].style.margin = "-0.02rem -0.02rem 0 -0.02rem"

            }
        },
        getQa() {
            axios.get(`https://public.rossoarts.com/api/v1/getQa?limit=18&page=1`).then((data) => {
                // console.log(data.data.data);
                this.qaData = this.arrGroup(data.data.data, 3)
                // this.qaTotal = data.data.total
                this.$nextTick(() => {
                    this.swiperT4()
                })
                // this.artsTutor = this.arrGroup(data.data.data.data, 4)
            })
        },
        jopMajorDetail(val) {
            var y6_main_img = document.getElementsByClassName("y6_main_img")
            var m2_item = document.getElementsByClassName("m2_item")
            for (var i = 0; i < m2_item.length; i++) {
                m2_item[i].style.borderColor = "transparent"
            }
            m2_item[val - 1].style.borderColor = "#FB6333"
            y6_main_img[0].src = require(`../img/yslx/${val}${val}.jpg`)
        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getSchool() {
            
            axios.get(`https://public.rossoarts.com/api/v1/getArtsSchools?c=${this.theCoutryId}&m=0&limit=4&page=1`).then((data) => {
                // console.log(this.arrGroup(data.data.data, 4));
                // console.log(data.data.data.data);
                this.schoolData = this.arrGroup(data.data.data.data, 4)
                this.$nextTick(() => {
                    this.mySwiper2Stick()
                })
            })
        },
        countryDetail(val,val2) {
            this.theCoutryId = val2
            this.getSchool()
            var y2_item = document.getElementsByClassName("y2_item")

            for (var i = 0; i < y2_item.length; i++) {
                y2_item[i].style.fontWeight = "400"
                y2_item[i].style.backgroundColor = "#F5E8D2"
            }
            y2_item[val].style.fontWeight = "bold"
            y2_item[val].style.backgroundColor = "#E1B578"

            this.theCountryData = this.countryData[val]
        },
        mySwiper2Stick() {
            var swiper = new Swiper(".mySwiper2", {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                observer: true,
                // loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
    },
    mounted() {
        var swiper = new Swiper(".mySwiperC1", {
            // slidesPerView: 3,
            // spaceBetween: 30,
            // effect:'cube', 
            // loop: true,

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
}
</script>